<template>
  <div class="create-game mb-4 pb-4">
    <StartTopBar/>
    <div class="container-sm">

      <div class="row d-flex justify-content-center">
        <div v-if="!game" class="spinner-border mt-3" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div v-if="!loading && game">
        <div class="row mb-2">
          <div class="col">
            <h4 class="text-left font-weight-bold text-danger mb-4">Join game</h4>
            <h5 class="text-left font-weight-bold mb-1">Room ID:</h5>
            <h5 class="text-left">{{ gameCode }}</h5>
          </div>
        </div>

        <div class="row mb-2">
          <form class="col" @submit.prevent="joinAGame">
            <div class="form-group">
              <h5 class="text-left font-weight-bold">Your name:</h5>
              <input v-on:keyup="checkDuplicateName" type="text" class="form-control" v-model="playerName">
              <h6 v-if="feedback" class="text-danger">{{ feedback }}</h6>
            </div>
          </form>
        </div>

        <div class="row">
          
        </div>

        <div class="row">
          <div class="col">
            <button @click="joinAGame" v-if="playerName && !feedback" type="button" class="btn btn-danger rounded-lg px-5">Join game</button>
            <button v-if="!playerName || feedback" type="button" class="btn btn-secondary rounded-lg px-5" disabled>Join game</button>
          </div>
        </div>
      </div>

      <div class="row d-flex justify-content-center">
        <div v-if="loading" class="spinner-border mt-3" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <hr class="mt-4">

      <HowToPlay class="mt-2"/>

    </div>
  </div>
</template>

<script>
import firebaseApp from '@/firebase/init'
import functions from 'firebase/functions'
import StartTopBar from '@/components/StartTopBar'
import HowToPlay from '@/components/HowToPlay'

export default {
  name: 'JoinGame',
  components: {
    StartTopBar,
    HowToPlay
  },
  data(){
    return{
      gameCode: this.$route.params.gameCode,
      game: null,
      playerName: null,
      loading: false,
      feedback: null
    }
  },
  methods: {
    checkDuplicateName(){
      if(this.playerName){
        let duplicateName = false
        this.game.players.forEach(player => {
          if(this.playerName === player.name){
            duplicateName = true
          }
        })
        if(duplicateName){
          this.feedback = 'Sorry bro... your friend chose this name already.'
        } else {
          this.feedback = null
        }
      }
    },
    joinAGame(){
      if(this.playerName && this.gameCode){
        this.loading = true
        let gameRef = firebaseApp.firestore().collection('games').where('gameCode', '==', this.gameCode)
        gameRef.get().then(snapshot => {
          snapshot.forEach(doc => {
            const masterFunction = firebaseApp.functions('asia-northeast1').httpsCallable('masterFunction')
            masterFunction({
              methodName: 'joinGame',
              gameCode: this.gameCode,
              playerName: this.playerName
            }).then(result => {
              if(!result.data.feedback){
                this.$router.push({ name: 'Game', params: {
                  playerCode: result.data.playerCode,
                  gameCode: result.data.gameCode
                }})
              } else {
                this.feedback = result.data.feedback
                this.loading = false
              }
            });
            this.playerName = null
            this.feedback = null
          })
        })
      }
    }
  },
  created() {
    if(this.gameCode) {
      const gameRef = firebaseApp.firestore()
      .collection('games')
      .where('gameCode', '==', this.gameCode)
      gameRef.onSnapshot(snapshot => {
        snapshot.forEach(doc => {
          this.game = {
            id: doc.id,
            ...doc.data()
          }
        })
      })
    } else {
      this.$router.push({ name: 'CreateGame' })
    }
  }
}
</script>
</script>

<style>
h3{
  font-size: 2em;
}
h4{
  font-size: 1.6em;
}
</style>




// WEBPACK FOOTER //
// src/components/JoinGame.vue